import React from "react";
import WarehouseLedger from "./warehouse-ledger";
import { fetchWarehouseMovements } from "./warehouse-api";
import { normalizeMovementRow } from "./warehouse-utils";

const COLUMNS = [
  { key: "fdate", title: "Дата", dataIndex: "fdate", width: 105, type: "date" },
  { key: "sklName", title: "Склад", dataIndex: "sklName", width: 170, ellipsis: true },
  { key: "tovName", title: "Товар", dataIndex: "tovName", width: 260, ellipsis: true },
  { key: "funit", title: "Ед.", dataIndex: "funit", width: 70 },
  { key: "sourceLabel", sortKey: "vidOsn", title: "Источник", dataIndex: "sourceLabel", width: 190, type: "source" },
  { key: "direction", sortKey: "vid", title: "Движение", dataIndex: "direction", width: 110 },
  { key: "signedKol", sortKey: "kol", title: "Количество", dataIndex: "signedKol", width: 120, align: "right", type: "number" },
  { key: "vidLabel", sortKey: "vid", title: "Вид", dataIndex: "vidLabel", width: 200 }
];

const WarehouseMovements = () => (
  <WarehouseLedger
    kind="movements"
    fetchPage={fetchWarehouseMovements}
    normalizeRow={normalizeMovementRow}
    columns={COLUMNS}
    productFilter
    sourceFilter
  />
);

export default WarehouseMovements;
